export default __webpack_public_path__ + "static/media/vertical.e724d1b8.svg";